import React from 'react';

const Loader = () => {
  const elements = [];
  for (let i = 1; i <= 12; i++) {
    elements.push(<div className={`hu-loader-element-${i}`} key={i} />);
  }

  return (
    <div className="hu-loader">
      {elements}
    </div>
  );
};

module.exports = Loader;



// WEBPACK FOOTER //
// ./src/components/loader.js